import { createSelector } from 'reselect';

const notificationSelector = (state) => state.notifications;

export const notifications = createSelector(
  [notificationSelector],
  (notifications) => notifications.notifications
);

export const fetchingNotifications = createSelector(
  [notificationSelector],
  (notifications) => notifications.fetchingNotifications
);

export const fetchedPageNumber = createSelector(
  [notificationSelector],
  (notifications) => notifications.pageNumberFetched
);

export const readingNotification = createSelector(
  [notificationSelector],
  (notifications) => notifications.readingNotification
);

export const deletingNotification = createSelector(
  [notificationSelector],
  (notifications) => notifications.deletingNotification
);

export const selectNewNotifications = createSelector(
  [notificationSelector],
  (notifications) => notifications.newNotifications
);